import { Checkbox, Col, Collapse, Input, Row, Typography } from "antd";
import { PromotionCodeModel } from "states/promotion-code/promotion-code.models";

export interface IPromotionCodeInformationTabProps {
  model: PromotionCodeModel;
  onChange: (newModel: PromotionCodeModel) => void;
  isUpdateMode: boolean;
}

export function PromotionCodeInformationTab(
  props: IPromotionCodeInformationTabProps
) {
  const { model, onChange, isUpdateMode } = props;
  return (
    <div>
      <Collapse defaultActiveKey={["1"]} className="mb-4">
        <Collapse.Panel key="1" header="Thông tin">
          <Row gutter={[16, 16]}>
            <Col span="12">
              <Input.Group className="mb-4">
                <Typography.Text>Mã: </Typography.Text>
                <Input
                  value={model.code}
                  readOnly={isUpdateMode}
                  onChange={(e) => {
                    onChange({ ...model, code: e.target.value?.toUpperCase() });
                  }}
                  placeholder="System generates"
                ></Input>
              </Input.Group>
              <Input.Group>
                <Checkbox
                  checked={model.active}
                  onChange={(e) => {
                    onChange({ ...model, active: e.target.checked });
                  }}
                >
                  Kích hoạt
                </Checkbox>
              </Input.Group>
            </Col>
          </Row>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}
